export default "__VITE_ASSET__Dk9iD55W__"